(function () {
  'use strict';

  var DATA_ID = 'tp-product-style-name-data';
  var CARD_SELECTOR = '.tp-product-card';
  var TITLE_SELECTOR = '.tp-product-card__title';
  var STYLE_CLASS = 'tp-product-card__style-name';
  var styleMap = {};
  var requestCache = new Map();

  function readStyleMap() {
    var dataNode = document.getElementById(DATA_ID);
    if (!dataNode) return;

    try {
      var parsed = JSON.parse(dataNode.textContent || '{}');
      if (parsed && typeof parsed === 'object') styleMap = parsed;
    } catch (error) {
      styleMap = {};
    }
  }

  function cleanValue(value) {
    return typeof value === 'string' ? value.trim() : '';
  }

  function getProductInfo(link) {
    try {
      var url = new URL(link.href, window.location.origin);
      var match = url.pathname.match(/\/products\/([^/?#]+)/);
      if (!match) return null;

      var encodedHandle = match[1];
      var handle = encodedHandle;

      try {
        handle = decodeURIComponent(encodedHandle);
      } catch (error) {}

      return {
        handle: handle,
        path: '/products/' + encodedHandle
      };
    } catch (error) {
      return null;
    }
  }

  function insertStyleName(card, title, value) {
    value = cleanValue(value);
    if (!value || card.querySelector('.' + STYLE_CLASS)) return;

    var styleName = document.createElement('div');
    styleName.className = STYLE_CLASS;
    styleName.textContent = value;
    title.insertAdjacentElement('afterend', styleName);
  }

  function fetchStyleName(productInfo) {
    if (!productInfo) return Promise.resolve('');

    var handle = productInfo.handle;
    var mappedValue = cleanValue(styleMap[handle]);

    if (mappedValue) return Promise.resolve(mappedValue);
    if (Object.prototype.hasOwnProperty.call(styleMap, handle)) return Promise.resolve('');

    if (requestCache.has(handle)) return requestCache.get(handle);

    var request = fetch(productInfo.path + '?view=style-name', {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (!response.ok) return '';
        return response.text();
      })
      .then(function (html) {
        if (!html) return '';

        var wrapper = document.createElement('div');
        wrapper.innerHTML = html;
        var node = wrapper.querySelector('[data-tp-style-name]');
        var value = node ? cleanValue(node.textContent) : '';
        styleMap[handle] = value;
        return value;
      })
      .catch(function () {
        return '';
      });

    requestCache.set(handle, request);
    return request;
  }

  function processCard(card) {
    if (!card || card.dataset.tpStyleNameReady === 'true') return;

    var title = card.querySelector(TITLE_SELECTOR);
    var link = title ? title.querySelector('a') : null;
    if (!title || !link) return;

    if (card.querySelector('.' + STYLE_CLASS)) {
      card.dataset.tpStyleNameReady = 'true';
      return;
    }

    var productInfo = getProductInfo(link);
    if (!productInfo) return;

    var mappedValue = cleanValue(styleMap[productInfo.handle]);
    if (mappedValue) {
      insertStyleName(card, title, mappedValue);
      card.dataset.tpStyleNameReady = 'true';
      return;
    }

    card.dataset.tpStyleNameReady = 'loading';

    fetchStyleName(productInfo).then(function (value) {
      insertStyleName(card, title, value);
      card.dataset.tpStyleNameReady = 'true';
    });
  }

  function processAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(CARD_SELECTOR).forEach(processCard);

    if (root && root.matches && root.matches(CARD_SELECTOR)) processCard(root);
  }

  function init() {
    readStyleMap();
    processAll(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) processAll(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
